var map = {
	"./dialogs/dialogs.en_EN.js": 55057,
	"./dialogs/dialogs.fr_FR.js": 90187,
	"./dialogs/dialogs.js": 37326,
	"./fonts.js": 40178,
	"./icons/icons.js": 31448,
	"./langs.js": 20752,
	"./loading/loading.en_EN.js": 10283,
	"./loading/loading.fr_FR.js": 5798,
	"./loading/loading.js": 8905,
	"./map/map.en_EN.js": 76278,
	"./map/map.fr_FR.js": 5085,
	"./map/map.js": 32982,
	"./map/map.mobile.en_EN.js": 53267,
	"./map/map.mobile.js": 689,
	"./menu/menu.en_EN.js": 78781,
	"./menu/menu.fr_FR.js": 11142,
	"./menu/menu.js": 11516,
	"./rotatescreen/rotatescreen.en_EN.js": 85671,
	"./rotatescreen/rotatescreen.fr_FR.js": 6821,
	"./rotatescreen/rotatescreen.js": 62366,
	"./scenes/scenes.en_EN.js": 5023,
	"./scenes/scenes.fr_FR.js": 96942,
	"./scenes/scenes.js": 83780,
	"./sounds/sounds.js": 92077,
	"./splashscreen/splashscreen.en_EN.js": 79165,
	"./splashscreen/splashscreen.fr_FR.js": 15576,
	"./splashscreen/splashscreen.js": 51947,
	"./tutorial/tutorial.en_EN.js": 83264,
	"./tutorial/tutorial.fr_FR.js": 87682,
	"./tutorial/tutorial.js": 19335,
	"./videos/videos.en_EN.js": 2066,
	"./videos/videos.fr_FR.js": 29881,
	"./videos/videos.js": 53002,
	"./videos/videos.mobile.en_EN.js": 33827,
	"./videos/videos.mobile.fr_FR.js": 97605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87134;